// extracted by mini-css-extract-plugin
export default {"inputwrapper":"FormStyles_inputwrapper__poRQL","areawrapper":"FormStyles_areawrapper__6YcL8","selectwrapper":"FormStyles_selectwrapper__oLKxp","input":"FormStyles_input__b4dfD"};